/**
 * A set of utility functions that adapts Request models to their UI equivalent
 */
import {UIRequestTask} from 'requests/tasks/RequestTaskConstants';
import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';

import {RequestTaskGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTaskGraphQL';

export function adaptRequestTasksGraphQLToUIRequestTasks(
  requestTasks: Array<RequestTaskGraphQL>
): Array<UIRequestTask> {
  return requestTasks.map((requestTask) => ({
    cid: requestTask.id,
    schemaId: requestTask.schema.id,
    tags: requestTask.tagsJson,
  }));
}

export function adaptSampleGroupsToPreparedUISampleGroups(
  preparedSampleGroups: Array<PreparedUISampleGroup>
): Array<PreparedUISampleGroup> {
  const filteredSampleGroups = preparedSampleGroups.filter(({id}) => id != null);
  return filteredSampleGroups.map(({id, tags}) => ({cid: id!, tags}));
}
